$(function(){
  // vars for testimonials carousel
  var $txtcarousel = $('#manual-slider-list');
  var txtcount = $txtcarousel.children().length;
  /* var wrapwidth = (txtcount * 415) + 415; // 400px width for each testimonial item
  $txtcarousel.css('width',wrapwidth);*/
  var animtime = 750; // milliseconds for clients carousel
  var slideCount = $(".slider-list-slide").length;

  $txtcarousel.find(".slider-list-slide").each(function(e, i) {
    var that = $(this);
    that.css("left", (e * 100) + "%" );

  });

  // prev & next btns for testimonials
  $('.prevbtn').on('click', function(){
    var last = $txtcarousel.find(".slider-list-slide:last");
    if (last.is(":last"))
      return true;

    last.detach().css({ "left" : "-100%"}).prependTo($txtcarousel);
    $txtcarousel.children().each(function(i) {
      $(this).animate({ "left" : (i * 100) + "%" }, animtime);
    });

  });

  $('.nextbtn').on('click', function(){
    var first = $txtcarousel.find(".slider-list-slide:first");
    if (first.is(":last"))
      return true;

    $txtcarousel.children().each(function(i2) {
      $(this).animate({ "left" : ((i2 - 1) * 100) + "%" }, animtime, function() {
        if (i2 == 0) {
          first.detach().css({"left" : ((slideCount - 1) * 100) + "%" }).appendTo($txtcarousel);
        }
      });
    });
  });


  // vars for clients list carousel
  // http://stackoverflow.com/questions/6759494/jquery-function-definition-in-a-carousel-script
  var $clientcarousel = $('#clients-list');
  var clients = $clientcarousel.children().length;
  var clientwidth = (clients * 140); // 140px width for each client item
  $clientcarousel.css('width',clientwidth);

  var rotating = true;
  var clientspeed = 1800;
  var seeclients = setInterval(rotateClients, clientspeed);

  $(document).on({
    mouseenter: function(){
      rotating = false; // turn off rotation when hovering
    },
    mouseleave: function(){
      rotating = true;
    }
  }, '#clients');

  function rotateClients() {
    if(rotating != false) {
      var $first = $('#clients-list li:first');
      $first.animate({ 'margin-left': '-140px' }, 600, function() {
        $first.remove().css({ 'margin-left': '0px' });
        $('#clients-list li:last').after($first);
      });
    }
  }
});